export const minesMultipliers: { mines: number; multi: number[] }[] = [
  {
    mines: 1,
    multi: [
      1.01, 1.05, 1.1, 1.15, 1.21, 1.28, 1.35, 1.43, 1.52, 1.62, 1.73, 1.87,
      2.02, 2.2, 2.43, 2.69, 3.03, 3.46, 4.04, 4.85, 6.06, 8.08, 12.13, 24.33,
    ],
  },
  {
    mines: 2,
    multi: [
      1.05, 1.15, 1.26, 1.39, 1.53, 1.7, 1.9, 2.14, 2.42, 2.77, 3.2, 3.73, 4.41,
      5.29, 6.47, 8.08, 10.39, 13.86, 19.4, 29.09, 48.49, 96.98, 290.97,
    ],
  },
  {
    mines: 3,
    multi: [
      1.1, 1.26, 1.45, 1.68, 1.96, 2.3, 2.73, 3.28, 3.98, 4.9, 6.13, 7.8, 10.14,
      13.52, 18.59, 26.56, 39.84, 63.75, 106.25, 193.18, 386.36, 930.99,
    ],
  },
  {
    mines: 5,
    multi: [
      1.21, 1.5, 1.87, 2.34, 2.96, 3.77, 4.84, 6.24, 8.32, 11.4, 15.83, 22.29,
      31.85, 46.83, 69.9, 107.54, 168.02, 270.14, 476.43, 992.57,
    ],
  },
  {
    mines: 7,
    multi: [
      1.29, 1.73, 2.32, 3.13, 4.28, 5.91, 8.19, 11.45, 16.08, 22.81, 32.44,
      46.68, 76.53, 126.49, 209.42, 347.29, 583.69, 997.75,
    ],
  },
  {
    mines: 10,
    multi: [
      1.5, 2.33, 3.61, 5.6, 8.69, 13.47, 20.89, 33.15, 52.62, 83.53, 132.58,
      210.45, 334.05, 530.24, 996.69,
    ],
  },
  {
    mines: 17,
    multi: [1.76, 3.53, 7.84, 18.23, 44.46, 108.44, 293.08, 996.88],
  },
  {
    mines: 20,
    multi: [2.77, 9.24, 30.79, 102.65, 996.56],
  },
  {
    mines: 24,
    multi: [24.25],
  },
];

export const minesMultipliersB: { mines: number; multi: number[] }[] = [
  {
    mines: 1,
    multi: [
      0.93, 0.97, 1.01, 1.06, 1.11, 1.17, 1.23, 1.31, 1.39, 1.48, 1.59, 1.71,
      1.85, 2.02, 2.22, 2.47, 2.77, 3.17, 3.7, 4.44, 5.55, 7.4, 11.1, 22.33,
    ],
  },
  {
    mines: 2,
    multi: [
      0.97, 1.05, 1.15, 1.27, 1.4, 1.56, 1.74, 1.96, 2.22, 2.54, 2.93, 3.42,
      4.04, 4.84, 5.92, 7.4, 9.51, 12.68, 17.76, 26.63, 44.39, 88.78, 266.38,
    ],
  },
  {
    mines: 3,
    multi: [
      1.01, 1.15, 1.33, 1.54, 1.79, 2.11, 2.5, 3.0, 3.65, 4.49, 5.61, 7.14,
      9.29, 12.38, 17.02, 24.32, 36.48, 58.36, 97.27, 176.85, 353.7, 930.79,
    ],
  },
  {
    mines: 5,
    multi: [
      1.11, 1.37, 1.71, 2.14, 2.71, 3.45, 4.43, 5.71, 7.62, 10.43, 14.49, 20.41,
      29.15, 42.87, 63.99, 98.45, 153.82, 248.1, 443.03, 984.52,
    ],
  },
  {
    mines: 7,
    multi: [
      1.18, 1.59, 2.15, 2.92, 4.0, 5.52, 7.67, 10.72, 15.1, 21.43, 30.61, 44.04,
      72.2, 119.33, 198.89, 331.48, 571.52, 993.95,
    ],
  },
  {
    mines: 10,
    multi: [
      1.38, 2.15, 3.36, 5.25, 8.21, 12.82, 20.03, 31.8, 50.48, 80.12, 127.18,
      201.87, 320.43, 508.62, 997.29,
    ],
  },
  {
    mines: 17,
    multi: [1.61, 3.23, 7.18, 16.69, 40.7, 99.27, 268.31, 993.72],
  },
  {
    mines: 20,
    multi: [2.54, 8.46, 28.19, 93.97, 939.68],
  },
  {
    mines: 24,
    multi: [22.2],
  },
];

export const minesMultipliersC: { mines: number; multi: number[] }[] = [
  {
    mines: 1,
    multi: [
      0.98, 1.02, 1.07, 1.12, 1.18, 1.24, 1.31, 1.38, 1.47, 1.57, 1.68, 1.81,
      1.96, 2.14, 2.35, 2.61, 2.94, 3.36, 3.92, 4.7, 5.88, 7.83, 11.75, 23.5,
    ],
  },
  {
    mines: 2,
    multi: [
      1.02, 1.11, 1.22, 1.34, 1.48, 1.65, 1.84, 2.07, 2.35, 2.69, 3.1, 3.62,
      4.27, 5.13, 6.27, 7.83, 10.07, 13.43, 18.8, 28.2, 47.0, 94.0, 282.0,
    ],
  },
  {
    mines: 3,
    multi: [
      1.07, 1.22, 1.4, 1.63, 1.9, 2.23, 2.65, 3.18, 3.86, 4.75, 5.94, 7.56,
      9.83, 13.1, 18.02, 25.74, 38.61, 61.77, 102.95, 187.19, 374.37, 985.19,
    ],
  },
  {
    mines: 5,
    multi: [
      1.18, 1.45, 1.81, 2.27, 2.87, 3.65, 4.69, 6.05, 8.06, 11.04, 15.34, 21.6,
      30.86, 45.38, 67.74, 104.21, 162.83, 262.63, 468.98, 997.82,
    ],
  },
  {
    mines: 7,
    multi: [
      1.31, 1.47, 1.69, 1.94, 2.23, 2.56, 2.94, 3.59, 4.38, 5.34, 6.51, 7.94,
      13.23, 22.05, 36.75, 61.25, 175.01, 972.29,
    ],
  },
  {
    mines: 10,
    multi: [
      1.46, 2.28, 3.56, 5.56, 8.69, 13.57, 21.21, 33.66, 53.43, 84.81, 134.63,
      213.69, 339.19, 538.4, 997.04,
    ],
  },
  {
    mines: 17,
    multi: [1.71, 3.42, 7.6, 17.67, 43.09, 105.09, 284.02, 979.37],
  },
  {
    mines: 20,
    multi: [2.69, 8.95, 29.84, 99.47, 994.71],
  },
  {
    mines: 24,
    multi: [23.5],
  },
];

export const minesMultipliers_86: { mines: number; multi: number[] }[] = [
  {
    mines: 1,
    multi: [
      0.9, 0.93, 0.98, 1.02, 1.08, 1.13, 1.19, 1.26, 1.34, 1.43, 1.54, 1.65,
      1.79, 1.95, 2.15, 2.39, 2.69, 3.07, 3.58, 4.3, 5.38, 7.17, 10.75, 21.5,
    ],
  },
  {
    mines: 2,
    multi: [
      0.93, 1.02, 1.12, 1.23, 1.36, 1.51, 1.69, 1.9, 2.15, 2.46, 2.83, 3.31,
      3.91, 4.69, 5.73, 7.17, 9.21, 12.28, 17.2, 25.8, 42.99, 85.98, 257.98,
    ],
  },
  {
    mines: 3,
    multi: [
      0.98, 1.12, 1.28, 1.49, 1.74, 2.04, 2.42, 2.91, 3.53, 4.35, 5.43, 6.92,
      8.99, 11.99, 16.49, 23.55, 35.33, 56.52, 94.2, 171.27, 342.55, 901.44,
    ],
  },
  {
    mines: 5,
    multi: [
      1.08, 1.33, 1.66, 2.07, 2.62, 3.34, 4.29, 5.53, 7.38, 10.1, 14.03, 19.76,
      28.23, 41.52, 61.97, 95.34, 148.97, 240.28, 429.06, 912.9,
    ],
  },
  {
    mines: 7,
    multi: [
      1.19, 1.34, 1.54, 1.77, 2.04, 2.34, 2.69, 3.28, 4.0, 4.88, 5.96, 7.26,
      12.1, 20.17, 33.62, 56.04, 160.12, 941.86,
    ],
  },
  {
    mines: 10,
    multi: [
      1.33, 2.08, 3.26, 5.09, 7.95, 12.42, 19.4, 30.8, 48.89, 77.6, 123.17,
      195.5, 310.32, 492.58, 965.84,
    ],
  },
  {
    mines: 17,
    multi: [1.56, 3.13, 6.95, 16.16, 39.42, 96.14, 259.85, 896.02],
  },
  {
    mines: 20,
    multi: [2.46, 8.19, 27.3, 91.01, 910.05],
  },
  {
    mines: 24,
    multi: [21.5],
  },
];

export const minesMultipliers_92: { mines: number; multi: number[] }[] = [
  {
    mines: 1,
    multi: [
      0.96, 1.0, 1.05, 1.1, 1.15, 1.21, 1.28, 1.35, 1.44, 1.53, 1.64, 1.77,
      1.92, 2.09, 2.3, 2.56, 2.87, 3.29, 3.83, 4.6, 5.75, 7.67, 11.5, 23.0,
    ],
  },
  {
    mines: 2,
    multi: [
      1.0, 1.09, 1.19, 1.31, 1.45, 1.61, 1.8, 2.03, 2.3, 2.63, 3.03, 3.54, 4.18,
      5.02, 6.13, 7.67, 9.86, 13.14, 18.4, 27.59, 45.99, 91.98, 275.98,
    ],
  },
  {
    mines: 3,
    multi: [
      1.05, 1.19, 1.37, 1.59, 1.86, 2.18, 2.59, 3.11, 3.78, 4.65, 5.81, 7.4,
      9.62, 12.83, 17.64, 25.19, 37.79, 60.46, 100.77, 183.22, 366.45, 964.33,
    ],
  },
  {
    mines: 5,
    multi: [
      1.15, 1.42, 1.77, 2.22, 2.81, 3.58, 4.59, 5.92, 7.89, 10.81, 15.01, 21.14,
      30.2, 44.42, 66.3, 101.99, 159.36, 257.04, 459.0, 976.59,
    ],
  },
  {
    mines: 7,
    multi: [
      1.28, 1.44, 1.65, 1.9, 2.18, 2.51, 2.88, 3.51, 4.28, 5.22, 6.37, 7.77,
      12.95, 21.58, 35.97, 59.95, 171.29, 978.79,
    ],
  },
  {
    mines: 10,
    multi: [
      1.42, 2.18, 3.53, 5.23, 8.18, 12.78, 19.97, 31.69, 50.31, 79.86, 126.76,
      201.2, 319.36, 506.93, 993.97,
    ],
  },
  {
    mines: 17,
    multi: [1.67, 3.53, 7.43, 17.29, 42.17, 102.85, 277.97, 958.53],
  },
  {
    mines: 20,
    multi: [2.63, 8.76, 29.21, 97.35, 973.54],
  },
  {
    mines: 24,
    multi: [23.0],
  },
];

export const minesMultipliers_93: { mines: number; multi: number[] }[] = [
  {
    mines: 1,
    multi: [
      0.97, 1.01, 1.06, 1.11, 1.16, 1.22, 1.29, 1.37, 1.45, 1.55, 1.66, 1.79,
      1.94, 2.11, 2.33, 2.58, 2.91, 3.32, 3.88, 4.65, 5.81, 7.75, 11.63, 23.25,
    ],
  },
  {
    mines: 2,
    multi: [
      1.01, 1.1, 1.21, 1.33, 1.47, 1.63, 1.82, 2.05, 2.32, 2.66, 3.07, 3.58,
      4.23, 5.07, 6.2, 7.75, 9.96, 13.28, 18.6, 27.89, 46.49, 92.98, 278.98,
    ],
  },
  {
    mines: 3,
    multi: [
      1.06, 1.21, 1.39, 1.61, 1.88, 2.21, 2.62, 3.15, 3.82, 4.7, 5.88, 7.48,
      9.72, 12.97, 17.83, 25.47, 38.2, 61.12, 101.87, 185.21, 370.43, 974.81,
    ],
  },
  {
    mines: 5,
    multi: [
      1.16, 1.44, 1.79, 2.24, 2.84, 3.62, 4.64, 5.98, 7.98, 10.93, 15.17, 21.37,
      30.53, 44.9, 67.02, 103.1, 161.1, 259.83, 463.99, 987.2,
    ],
  },
  {
    mines: 7,
    multi: [
      1.29, 1.45, 1.67, 1.92, 2.2, 2.53, 2.91, 3.55, 4.33, 5.28, 6.44, 7.85,
      13.09, 21.82, 36.36, 60.6, 173.15, 989.43,
    ],
  },
  {
    mines: 10,
    multi: [
      1.43, 2.2, 3.39, 5.21, 8.14, 12.72, 19.87, 31.55, 50.07, 79.48, 126.16,
      200.26, 317.87, 504.55, 989.32,
    ],
  },
  {
    mines: 17,
    multi: [1.69, 3.38, 7.52, 17.48, 42.63, 103.97, 281.0, 968.95],
  },
  {
    mines: 20,
    multi: [2.66, 8.86, 29.52, 98.41, 984.13],
  },
  {
    mines: 24,
    multi: [23.25],
  },
];

export const minesMultipliers_94: { mines: number; multi: number[] }[] = [
  {
    mines: 1,
    multi: [
      0.98, 1.02, 1.07, 1.12, 1.18, 1.24, 1.31, 1.38, 1.47, 1.57, 1.68, 1.81,
      1.96, 2.14, 2.35, 2.61, 2.94, 3.36, 3.92, 4.7, 5.88, 7.83, 11.75, 23.5,
    ],
  },
  {
    mines: 2,
    multi: [
      1.02, 1.11, 1.22, 1.34, 1.48, 1.65, 1.84, 2.07, 2.35, 2.69, 3.1, 3.62,
      4.27, 5.13, 6.27, 7.83, 10.07, 13.43, 18.8, 28.2, 47.0, 94.0, 282.0,
    ],
  },
  {
    mines: 3,
    multi: [
      1.07, 1.22, 1.4, 1.63, 1.9, 2.23, 2.65, 3.18, 3.86, 4.75, 5.94, 7.56,
      9.83, 13.1, 18.02, 25.74, 38.61, 61.77, 102.95, 187.19, 374.37, 985.19,
    ],
  },
  {
    mines: 5,
    multi: [
      1.18, 1.45, 1.81, 2.27, 2.87, 3.65, 4.69, 6.05, 8.06, 11.04, 15.34, 21.6,
      30.86, 45.38, 67.74, 104.21, 162.83, 262.63, 468.98, 997.82,
    ],
  },
  {
    mines: 7,
    multi: [
      1.31, 1.47, 1.69, 1.94, 2.23, 2.56, 2.94, 3.59, 4.38, 5.34, 6.51, 7.94,
      13.23, 22.05, 36.75, 61.25, 175.01, 972.29,
    ],
  },
  {
    mines: 10,
    multi: [
      1.46, 2.28, 3.56, 5.56, 8.69, 13.57, 21.21, 33.66, 53.43, 84.81, 134.63,
      213.69, 339.19, 538.4, 997.04,
    ],
  },
  {
    mines: 17,
    multi: [1.71, 3.42, 7.6, 17.67, 43.09, 105.09, 284.02, 979.37],
  },
  {
    mines: 20,
    multi: [2.69, 8.95, 29.84, 99.47, 994.71],
  },
  {
    mines: 24,
    multi: [23.5],
  },
];

export const minesMultipliers_95: { mines: number; multi: number[] }[] = [
  {
    mines: 1,
    multi: [
      0.99, 1.03, 1.08, 1.13, 1.19, 1.25, 1.32, 1.4, 1.48, 1.58, 1.7, 1.83,
      1.98, 2.16, 2.38, 2.64, 2.97, 3.39, 3.96, 4.75, 5.94, 7.92, 11.88, 23.75,
    ],
  },
  {
    mines: 2,
    multi: [
      1.03, 1.13, 1.23, 1.36, 1.5, 1.67, 1.86, 2.1, 2.37, 2.71, 3.13, 3.65,
      4.32, 5.18, 6.33, 7.92, 10.18, 13.57, 19.0, 28.49, 47.49, 94.98, 284.97,
    ],
  },
  {
    mines: 3,
    multi: [
      1.08, 1.23, 1.42, 1.64, 1.92, 2.26, 2.68, 3.21, 3.9, 4.8, 6.0, 7.64, 9.93,
      13.24, 18.21, 26.02, 39.02, 62.44, 104.06, 189.2, 378.39, 995.78,
    ],
  },
  {
    mines: 5,
    multi: [
      1.19, 1.47, 1.83, 2.29, 2.9, 3.69, 4.74, 6.11, 8.15, 11.16, 15.5, 21.83,
      31.19, 45.87, 68.46, 105.32, 164.56, 265.42, 473.96, 987.43,
    ],
  },
  {
    mines: 7,
    multi: [
      1.32, 1.48, 1.7, 1.96, 2.25, 2.59, 2.97, 3.63, 4.42, 5.39, 6.58, 8.02,
      13.37, 22.29, 37.14, 61.91, 176.87, 982.63,
    ],
  },
  {
    mines: 10,
    multi: [
      1.46, 2.25, 3.46, 5.32, 8.32, 12.99, 20.3, 32.22, 51.15, 81.19, 128.87,
      204.56, 324.7, 515.4, 991.16,
    ],
  },
  {
    mines: 17,
    multi: [1.73, 3.45, 7.68, 17.85, 43.54, 106.2, 287.04, 989.79],
  },
  {
    mines: 20,
    multi: [2.71, 9.05, 30.16, 100.53, 957.42],
  },
  {
    mines: 24,
    multi: [23.75],
  },
];
